module.exports = __webpack_public_path__ + "static/media/calendar-lembrete.b86d83b2.svg";